import PropTypes from "prop-types";
import { createContext, useState } from "react";

// initial state
const initialState = {
  fontFamily: `'IBM Plex Sans', sans-serif`,
  borderRadius: 2,
  container: true,
};

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

const ConfigContext = createContext(initialState);

function ConfigProvider({ children }) {
  const [config, setConfig] = useState(initialState);

  return (
    <ConfigContext.Provider
      value={{
        config,
        setConfig,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
}

ConfigProvider.propTypes = {
  children: PropTypes.node,
};

export { ConfigProvider, ConfigContext };
